import React from 'react';
import { brand } from '../config/brand';

interface BrandLogoProps {
  /** Classes applied when the brand has a logo image asset. */
  imgClassName?: string;
  /** Classes applied to the text wordmark fallback (brands without a logo asset). */
  textClassName?: string;
}

/**
 * Renders the active brand's logo: an <img> when the brand ships a logo asset,
 * otherwise a styled text wordmark of the brand name. Keeps every page
 * brand-agnostic.
 */
const BrandLogo: React.FC<BrandLogoProps> = ({ imgClassName, textClassName }) => {
  if (brand.logo) {
    return <img src={brand.logo} alt={brand.name} className={imgClassName} />;
  }
  return <span className={textClassName}>{brand.name}</span>;
};

export default BrandLogo;
